<template>
<section :class="[block.class, {'half-padding-top': block.half_padding_top}, {'half-padding-bottom': block.half_padding_bottom}, 'section', block.bgcolour]" :id="block.anchor ? block.anchor : ('block-' + block.id)">
    <div class="container">
        <div class="columns is-variable is-6">
            <div class="column is-4">
                <h2 class="title">{{block.title}}</h2>
            </div>
            <div class="column is-8">
                <div class="content" v-if="block.content" ref="content" v-html="block.content"></div>
                <agile v-if="block.carou_with_content && block.carousel && block.carousel.items.length > 0" :options="block.carousel.config">
                    <template v-for="item, i in block.carousel.items">
                        <div class="column" v-if="item.image">
                            <img :class="{'is-bordered': block.carousel.config.image_bordered}" v-if="!item.link" :src="item.image.url" :alt="item.image.title" />
                            <template v-else>
                                <router-link :target="item.link.open_in_blank ? '_blank' : null" v-if="item.link.is_internal" :to="item.link.url"><img :class="{'is-bordered': block.carousel.config.image_bordered}" :src="item.image.url" :alt="item.image.title" /></router-link>
                                <a :target="item.link.open_in_blank ? '_blank' : null" v-else :href="item.link.url"><img :class="{'is-bordered': block.carousel.config.image_bordered}" :alt="item.image.title" :src="item.image.url" /></a>
                            </template>
                        </div>
                    </template>
                    <template slot="prevButton">‹</template>
                    <template slot="nextButton">›</template>
                </agile>
            </div>
        </div>
        <agile v-if="!block.carou_with_content && block.carousel && block.carousel.items.length > 0" :options="block.carousel.config">
            <template v-for="item, i in block.carousel.items">
                <div class="column" v-if="item.image">
                    <img :alt="item.image.title" :class="{'is-bordered': block.carousel.config.image_bordered}" v-if="!item.link" :src="item.image.url" />
                    <template v-else>
                        <router-link :target="item.link.open_in_blank ? '_blank' : null" v-if="item.link.is_internal" :to="item.link.url"><img :class="{'is-bordered': block.carousel.config.image_bordered}" :src="item.image.url" :alt="item.image.title" /></router-link>
                        <a :target="item.link.open_in_blank ? '_blank' : null" v-else :href="item.link.url">
                            <img :class="{'is-bordered': block.carousel.config.image_bordered}" :alt="item.image.title" :src="item.image.url" />
                        </a>
                    </template>
                </div>
            </template>
            <template slot="prevButton">‹</template>
            <template slot="nextButton">›</template>
        </agile>
    </div>
</section>
</template>

<script>
import { VueAgile } from 'vue-agile'
import BlockCommons from '../../mixins/BlockCommons';
export default {
    name    :   'TitleContentSideBySideCarouselBlock',
    mixins  :   [ BlockCommons ],
    components  :   {
        agile   :   VueAgile
    },
    mounted() {
        this.$nextTick().then(() => {
            if (this.$refs.content) {
                this.HandleContentedLinks(this.$refs.content, this)
            }
        })
    },
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/TitleContentSideBySideCarouselBlock.vue